import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpErrorResponse, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import {EventManager} from '../services';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class ErrorHandlerInterceptor implements HttpInterceptor {
  constructor(
    private eventManager: EventManager,
    private toast: ToastrService
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      tap(
        (event: HttpEvent<any>) => {},
        (err: any) => {
          if (err instanceof HttpErrorResponse) {
            const message = err.error.message || err.error.body && err.error.body.message;
            if (!(err.status === 401 )) {
              this.eventManager.broadcast({ name: 'Fmarket.httpError', content: message });
            } else {
              this.eventManager.broadcast({ name: 'Fmarket.authenError', content: err });
            }
          }
          return err;
        }
      )
    );
  }
}
